import React from "react";
import styles from "./index.module.css";
import { Dropdown } from "primereact/dropdown";

interface DropdownOption {
    id: number;
    description: string;
}


const renderDropdown = <T extends DropdownOption>(
    options: T[],
    label: string,
    onChange: (e: { value: T | null }) => void,
    value: T | null,
    isDisabled = false,
    isLoading = false,
    
): JSX.Element => (
    <div className={styles.filterItem}>
        <label className={styles.filterLabel}>{label} :</label>
        <Dropdown
            options={options}
            optionLabel="description"
            placeholder="Selecione"
            value={value}
            onChange={(e) => onChange(e)}
            className={`${styles.dropdown} ${styles.dropDownChart}`}
            disabled={isDisabled}
            loading ={isLoading}
            
        />
    </div>
);
export default renderDropdown;